// ------------------------------------
// FOTOS (CARROSSEL)
// ------------------------------------
$(function () {
  const dots =
    $(".produto-det-foto").length > 1 && $(".produto-det-foto").length <= 10;
  // Carrosel fotos
  $(".produto-det-fotos").slick({
    lazyLoad: "ondemand",
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    dots: dots,
    arrows: true,
    fade: true,
    swipe: false,
    //asNavFor: ".produto-det-thumbs",
    responsive: [
      // Tablet & Mobile
      {
        breakpoint: 960,
        settings: {
          fade: false,
          swipe: true,
        },
      },
    ],
  });
  // Carrosel thumbs
  $(".produto-det-thumbs").slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    focusOnSelect: true,
    infinite: false,
    arrows: false,
    asNavFor: ".produto-det-fotos",
    // Responsivo
    responsive: [
      // Tablet & Mobile
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });
  AOS.refresh();
});

// ------------------------------------
// Zoom
// ------------------------------------
(function () {
  "use strict";

  if ($(window).width() > 960) {
    $(".produto-det-foto").each(function () {
      const $el = $(this);
      const imgLg = $(this).attr("href");
      if (imgLg) {
        $el.zoom({
          url: imgLg,
        });
      }
    });
  }
})();
